import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'empId',
      type: 'input',
      label: '企微账号',
      clearable: true,
      placeholder: '请输入企微账号'
    },
    {
      field: 'corpId',
      type: 'select',
      label: '所属主体',
      filterable: true,
      clearable: true,
      placeholder: '请选择所属主体',
      options: [
        {title: '天鼎证券投顾', value: 'ww3535c85e83b16e9e'}
      ]
    },
    {
      field: 'welcome',
      type: 'input',
      label: '欢迎语',
      clearable: true,
      placeholder: '请输入关键词'
    }
  ]
}
